import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { IoAdd, IoRemove } from "react-icons/io5";
import { NumericFormat } from "react-number-format";

const Cart = ({ cart, setCart, handleChange }) => {
    const [clientId, setSelectedClient] = useState(null);
    const [last_time_paid, setTimePaid] = useState("");
    const [start_guarantee, setStartGuarantee] = useState('');
    const [end_guarantee, setEndGuarantee] = useState('');
    const [start_contract, setStartContract] = useState('');
    const [end_contract, setEndContract] = useState('');
    const [contract_value, setContractValue] = useState(0);
    const [paid_amount, setPaidAmount] = useState(0);
    const [paid_status, setPaidStatus] = useState("");
    const [note, setNote] = useState("");
    const [payment_method, setPaymentMethod] = useState("");
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [msg, setMsg] = useState("");
    const navigate = useNavigate();
    // Access the environment variables
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    const handleRemove = (id) => {
        const arr = cart.filter((item) => item.uuid !== id);
        setCart(arr);
    };

    useEffect(() => {
        const fetchOptions = async () => {
          setIsLoading(true);
          try {
            // Replace with your actual Node.js API endpoint
            const result = await axios.get(`${API_BASE_URL}/client`, {
                headers: {
                    'X-API-Key': API_KEY
                },
            }); 
            const data = result.data;

            // Map the API data to the format react-select expects: { value: '', label: '' }
            const formattedOptions = data.map(itemselect => ({
              value: itemselect.id,
              label: itemselect.name+" - "+itemselect.address,
            }));

            setOptions(formattedOptions);
            setError(null);
          } catch (err) {
            setError('Failed to load options');
            console.error(err);
          } finally {
            setIsLoading(false);
          }
        };

      fetchOptions();
    }, []);

    const handleStartGuaranteeChange = (event) => {
      setStartGuarantee(event.target.value);
    };
    
    const handleEndGuaranteeChange = (event) => {
      setEndGuarantee(event.target.value);
    };

    const handleStartContractChange = (event) => {
      setStartContract(event.target.value);
    };
    
    const handleEndContractChange = (event) => {
      setEndContract(event.target.value);
    };

    const handleTimePaidChange = (event) => {
      setTimePaid(event.target.value);
    };

    const handleClientChange = (selectedOption) => {
      setSelectedClient(selectedOption);
      console.log('Option selected:', selectedOption);
    };
    
    const handlePaidAmountChange = (values) => {
      const { floatValue } = values;
      setPaidAmount(floatValue); 
    };

    const handleContractValueChange = (values) => {
      const { floatValue } = values;
      setContractValue(floatValue); 
    };

    const saveContract = async (e) => {
      e.preventDefault();    
      try {
        await axios.post(`${API_BASE_URL}/contracts`, {
            headers: {
                'X-API-Key': API_KEY
            },
            last_time_paid: last_time_paid,
            contract_value: contract_value,
            paid_amount: paid_amount,            
            paid_status: paid_status,
            clientId: clientId.value,
            start_guarantee: start_guarantee,
            end_guarantee: end_guarantee,
            start_contract: start_contract,
            end_contract: end_contract,
            payment_method: payment_method,
            note: note,
            cart
        });
        navigate("/contracts");
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };

  return (
    <div className="container">
        <div className="columns">
            <div className="column is-centered">
                <h1 className="title has-text-centered is-size-5">Form Contract</h1>
                <div className="card is-shadowless">
                    <h1 className="title is-size-5">List Item:</h1>
                    <table className="table is-bordered is-striped is-fullwidth is-size-6">
                        <thead>
                            <tr>
                                <th style={{width: "1%"}}>No</th>
                                <th className="has-text-centered" style={{width: "5%"}}>Image</th>
                                <th className="has-text-centered" style={{width: "30%"}}>Product_Name</th>
                                <th className="has-text-centered">Serial_Number</th>
                                <th className="has-text-centered">Qty</th>
                                <th className="has-text-centered">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cart.map((item, index) => (
                                <tr key={item.uuid}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <figure className="image is-48x48">
                                            <img src={item.url} alt="Image" />
                                        </figure>
                                    </td>
                                    <td>{item.name}</td>
                                    <td className="has-text-centered">
                                        {item.serialnumber}
                                    </td>                            
                                    <td className="has-text-centered">
                                        <div className="is-inline-flex">
                                            <div className="buttons has-addons is-centered">
                                                <button className="button is-dark" onClick={() => handleChange(item, 1)}><IoAdd /></button>
                                                <button className="button">{item.amount}</button>
                                                <button className="button is-dark" onClick={() => handleChange(item, -1)}><IoRemove /></button>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="has-text-centered">
                                        <button className="button is-small is-danger" onClick={() => handleRemove(item.uuid)}>Remove</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>                    
                    <form onSubmit={saveContract}>
                        <p className="has-text-left has-text-danger">{msg}</p>
                        <div className="field columns">
                            <div className="column is-6">
                            <label className="label">Client/Customer</label>
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            <div className="control">
                                <div className="is-fullwidth">
                                <Select
                                    value={clientId}
                                    onChange={handleClientChange}
                                    options={options}
                                    isLoading={isLoading}
                                    isClearable={true} 
                                    placeholder="Select Client/Customer"
                                    required
                                    />
                                </div>
                            </div>
                            </div>
                            <div className="column">
                            <label className="label">&nbsp;</label>
                            <Link to="/clients/add" className="button is-small is-primary">
                                New Client
                            </Link>
                            </div>
                        </div>
                        <div className="field columns">
                            <div className="column is-3">
                                <label className="label">Contract_Value</label>
                                <div className="control">
                                    <NumericFormat
                                    id="contract_value"
                                    className="input"
                                    value={contract_value}
                                    onValueChange={handleContractValueChange}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    valueIsNumericString={true} 
                                    required
                                    />
                                </div>
                            </div>
                            <div className="column is-2">
                                <label className="label">Start_Contract</label>
                                <div className="control">
                                    <div className="is-fullwidth">
                                        <input className="input"
                                            type="date"
                                            id="start_contract"
                                            name="start_contract"
                                            value={start_contract} // Controlled component
                                            onChange={handleStartContractChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="column is-2">
                                <label className="label">End_Contract</label>
                                <div className="control">
                                    <div className="is-fullwidth">
                                        <input className="input"
                                            type="date"
                                            id="end_contract"
                                            name="end_contract"
                                            value={end_contract} // Controlled component
                                            onChange={handleEndContractChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="column is-2">
                                <label className="label">Start_Guarantee</label>
                                <div className="control">
                                    <div className="is-fullwidth">
                                        <input className="input"
                                            type="date"
                                            id="start_guarantee"
                                            name="start_guarantee"
                                            value={start_guarantee} // Controlled component
                                            onChange={handleStartGuaranteeChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="column is-2">
                                <label className="label">End_Guarantee</label>
                                <div className="control">
                                    <div className="is-fullwidth">
                                        <input className="input"
                                            type="date"
                                            id="end_guarantee"
                                            name="end_guarantee"
                                            value={end_guarantee} // Controlled component
                                            onChange={handleEndGuaranteeChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div className="field columns">
                            <div className="column is-3">
                                <label className="label">Paid_Status</label>
                                <div className="control">
                                    <div className="select is-fullwidth">
                                    <select
                                        required
                                        value={paid_status}
                                        onChange={(e) => setPaidStatus(e.target.value)}
                                    >
                                        <option value="">Select Paid Status</option>
                                        <option value="Paid">Paid</option>
                                        <option value="Partial">Partial</option>
                                        <option value="Unpaid">Unpaid</option>
                                    </select>
                                    </div>
                                </div>
                            </div>
                            <div className="column is-3">
                                <label className="label">Paid_Amount</label>
                                <div className="control">
                                    <NumericFormat
                                    id="paid_amount"
                                    className="input"
                                    value={paid_amount}
                                    onValueChange={handlePaidAmountChange}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    valueIsNumericString={true} 
                                    placeholder="Paid Amount"
                                    />
                                </div>
                            </div>
                            <div className="column is-3">
                                <label className="label">Payment Method</label>
                                <div className="select is-fullwidth">
                                    <select
                                    value={payment_method}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                    required
                                    >
                                    <option value="">Select Payment Method</option>
                                    <option value="Cash">Cash</option>
                                    <option value="Transfer">Transfer</option>
                                    </select>
                                </div>
                            </div>
                            <div className="column is-3">
                                <label className="label">Time_Paid</label>
                                <div className="control">
                                    <div className="is-fullwidth">
                                        <input className="input"
                                            type="datetime-local"
                                            id="time_paid"
                                            name="time_paid"
                                            value={last_time_paid} // Controlled component
                                            onChange={handleTimePaidChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Payment_Notes</label>
                            <div className="control">
                                <textarea
                                    className="textarea"
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    placeholder="Note"
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>            
                        <div className="field">
                            <Link to="/contracts">
                            <button className="button is-warning mr-1">
                                Cancel
                            </button>
                            </Link>
                            <button type="submit" className="button is-success">
                                Save
                            </button>
                        </div>          
                    </form>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Cart;